import { useI18n } from '@/hooks/useI18n';
import { IDIOMA_ORIGINAL, buscarIdioma } from '@/i18n/idiomas';
import styles from './LegalDocumentPage.module.css';

/**
 * Leyenda de traducción de cortesía.
 *
 * Los avisos y términos se redactaron en español y citan la ley mexicana: esa
 * es la versión vinculante. Una traducción que se lea como si tuviera el mismo
 * valor jurídico no es una comodidad, es una exposición — de ahí que esto sea
 * un aviso visible dentro del documento y no una nota al pie.
 *
 * No aparece en el idioma original, donde no habría nada que advertir. El botón
 * lleva a la versión vinculante sin salir de la página: quien necesita el texto
 * que manda lo tiene a un clic.
 */
export function AvisoDeTraduccion() {
  const { t, idioma, cambiarIdioma } = useI18n();

  if (idioma === IDIOMA_ORIGINAL) return null;

  const original = buscarIdioma(IDIOMA_ORIGINAL);

  return (
    <p className={styles.avisoTraduccion} role="note">
      {t.legal.avisoTraduccion}{' '}
      <button
        type="button"
        className={styles.avisoEnlace}
        onClick={() => cambiarIdioma(IDIOMA_ORIGINAL)}
        lang={IDIOMA_ORIGINAL}
      >
        {t.legal.verEnEspanol}
      </button>
      {original ? <span className="ilu-sr-only"> ({original.etiqueta})</span> : null}
    </p>
  );
}
